import { AxiosRequestConfig, AxiosResponse } from "axios";
import { axiosInst } from "./axiosHVS";

export const patchPresetsAzimuth = (
  typeId: string,
  data: PresetPositioningData[],
  config?: AxiosRequestConfig
): Promise<AxiosResponse<unknown>> => {
  const baseCameraKey = `bulk/entitytypes/${typeId}/entities/patch/`;
  const requestBody = data.map((d) => {
    return {
      entity_id: d.id,
      patch: [
        {
          op: "replace",
          path: "/attributes/azimuth/value",
          value: d.azimuth,
        },
      ],
    };
  });
  return axiosInst.post(`${baseCameraKey}`, requestBody, config);
};
